let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bfTAm")).then(() => parcelRequire('a3iQa'));